import { render, staticRenderFns } from "./AcademyLikesDisplay.vue?vue&type=template&id=1253e5ad&scoped=true"
import script from "./AcademyLikesDisplay.vue?vue&type=script&lang=js"
export * from "./AcademyLikesDisplay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1253e5ad",
  null
  
)

export default component.exports